/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['h1[_ngcontent-%COMP%] {\r\n	\r\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovW1Byb2plY3RzXS9XZWJTUEguZ2l0cy9XZWJTUEguZ2l0L3NyYy91aS9yb290L3dlYnNwaC1yb290LmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovW1Byb2plY3RzXS9XZWJTUEguZ2l0cy9XZWJTUEguZ2l0L3NyYy91aS9yb290L3dlYnNwaC1yb290LmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// D:/[Projects]/WebSPH.gits/WebSPH.git/src/$$_gendir/ui/root/websph-root.component.css.shim.ngstyle.ts